import styles from './styles.module.css'

type ComponentProps = {
  id: number
  name: string
  isDisabled?: boolean
  onClick: VoidFunction
}

export const Tag = ({ id, name, isDisabled, onClick }: ComponentProps): JSX.Element => {
  return (
    <div key={id} className={`${styles.unitTag} ${styles.tagPadding}`}>
      <span className={styles.unitName}>{name}</span>
      {!isDisabled && (
        <span className={styles.tagRemove} onClick={onClick}>
          &times;
        </span>
      )}
    </div>
  )
}
